// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';

// const Attractions = () => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const navigate = useNavigate();

//   const images = [
//     {
//       src: '/images/latarniamorska.jpg',
//       title: 'Latarnia Morska w Rozewiu',
//       subtitle: 'Zabytkowa latarnia z muzeum latarnictwa'
//     },
//     {
//       src: '/images/klifwjastrzebiejgorze.jpg',
//       title: 'Klif w Jastrzębiej Górze',
//       subtitle: 'Malownicze wybrzeże klifowe'
//     },
//     {
//       src: '/images/wawoz.jpg',
//       title: 'Wąwóz Chłapowski',
//       subtitle: 'Piękny rezerwat przyrody'
//     },
//     {
//       src: '/images/plazajastrzebiagora.jpg',
//       title: 'Plaże Jastrzębiej Góry',
//       subtitle: 'Złociste piaski nad Bałtykiem'
//     }
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prev) => (prev + 1) % images.length);
//     }, 10000);
//     return () => clearInterval(interval);
//   }, [images.length]);

//   const goToDetails = () => {
//     navigate('/atrakcje');
//   };

//   return (
//     <section className="relative h-screen overflow-hidden">
//       <AnimatePresence mode='wait'>
//         <motion.div
//           key={currentImageIndex}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//           className="absolute inset-0"
//         >
//           <img 
//             src={images[currentImageIndex].src} 
//             alt={images[currentImageIndex].title}
//             className="w-full h-full object-cover"
//           />
//           <div 
//             className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center text-white text-center cursor-pointer"
//             onClick={goToDetails}
//           >
//             <motion.h2 
//               initial={{ y: -50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.3 }}
//               className="text-4xl md:text-6xl font-bold mb-4"
//             >
//               Odkryj Jastrzębią Górę i okolice
//             </motion.h2>
//             <motion.p
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.6 }}
//               className="text-xl md:text-2xl mb-8"
//             >
//               {images[currentImageIndex].title} - {images[currentImageIndex].subtitle}
//             </motion.p>
//             <motion.button
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ delay: 0.9 }}
//               className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors duration-300"
//             >
//               Poznaj wszystkie atrakcje
//             </motion.button>
//           </div>
//         </motion.div>
//       </AnimatePresence>
      
//       {/* Pager */}
//       <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-2">
//         {images.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentImageIndex(index)}
//             className={`w-3 h-3 rounded-full ${currentImageIndex === index ? 'bg-yellow-500' : 'bg-white bg-opacity-50'}`}
//             aria-label={`Przejdź do slajdu ${index + 1}`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Attractions;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';

// const Attractions = () => {
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [attractionsData, setAttractionsData] = useState({
//     slider: {
//       images: [
//         {
//           src: '/images/latarniamorska.jpg',
//           title: 'Latarnia Morska w Rozewiu',
//           subtitle: 'Zabytkowa latarnia z muzeum latarnictwa'
//         }
//       ]
//     }
//   });
//   const navigate = useNavigate();

//   useEffect(() => {
//     const savedData = localStorage.getItem('attractionsData');
//     if (savedData) {
//       try {
//         setAttractionsData(JSON.parse(savedData));
//       } catch (error) {
//         console.error('Błąd parsowania danych atrakcji:', error);
//       }
//     }
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentImageIndex((prev) => (prev + 1) % attractionsData.slider.images.length);
//     }, 10000);
//     return () => clearInterval(interval);
//   }, [attractionsData.slider.images.length]);

//   const goToDetails = () => {
//     navigate('/atrakcje');
//   };

//   return (
//     <section className="relative h-screen overflow-hidden">
//       <AnimatePresence mode='wait'>
//         <motion.div
//           key={currentImageIndex}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//           className="absolute inset-0"
//         >
//           <img 
//             src={attractionsData.slider.images[currentImageIndex].src} 
//             alt={attractionsData.slider.images[currentImageIndex].title}
//             className="w-full h-full object-cover"
//           />
//           <div 
//             className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center text-white text-center cursor-pointer"
//             onClick={goToDetails}
//           >
//             <motion.h2 
//               initial={{ y: -50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.3 }}
//               className="text-4xl md:text-6xl font-bold mb-4"
//             >
//               Odkryj Jastrzębią Górę i okolice
//             </motion.h2>
//             <motion.p
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.6 }}
//               className="text-xl md:text-2xl mb-8"
//             >
//               {attractionsData.slider.images[currentImageIndex].title} - {attractionsData.slider.images[currentImageIndex].subtitle}
//             </motion.p>
//             <motion.button
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ delay: 0.9 }}
//               className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors duration-300"
//             >
//               Poznaj wszystkie atrakcje
//             </motion.button>
//           </div>
//         </motion.div>
//       </AnimatePresence>
      
//       {/* Pager */}
//       <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-2">
//         {attractionsData.slider.images.map((_, index) => (
//           <button
//             key={index}
//             onClick={() => setCurrentImageIndex(index)}
//             className={`w-3 h-3 rounded-full ${currentImageIndex === index ? 'bg-yellow-500' : 'bg-white bg-opacity-50'}`}
//             aria-label={`Przejdź do slajdu ${index + 1}`}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Attractions;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';

// const Attractions = () => {
//   const API_BASE = 'http://localhost/api';
  
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [attractionsData, setAttractionsData] = useState({
//     slider: {
//       images: [
//         {
//           src: '/images/latarniamorska.jpg',
//           title: 'Latarnia Morska w Rozewiu',
//           subtitle: 'Zabytkowa latarnia z muzeum latarnictwa'
//         }
//       ]
//     }
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchAttractionsData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/attractions.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych atrakcji');
//         }
        
//         const data = await response.json();
//         setAttractionsData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych atrakcji:', error);
//         setError('Nie udało się załadować danych atrakcji. Wyświetlam domyślną zawartość.');
//         // Używamy domyślnych danych w przypadku błędu
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAttractionsData();
//   }, []);

//   useEffect(() => {
//     if (attractionsData.slider.images.length > 0) {
//       const interval = setInterval(() => {
//         setCurrentImageIndex((prev) => (prev + 1) % attractionsData.slider.images.length);
//       }, 10000);
//       return () => clearInterval(interval);
//     }
//   }, [attractionsData.slider.images.length]);

//   const goToDetails = () => {
//     navigate('/atrakcje');
//   };

//   if (loading) {
//     return (
//       <section className="relative h-screen overflow-hidden bg-gray-100 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//       </section>
//     );
//   }

//   return (
//     <section className="relative h-screen overflow-hidden">
//       <AnimatePresence mode='popLayout'>
//         <motion.div
//           key={currentImageIndex}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 1 }}
//           className="absolute inset-0"
//         >
//           <img 
//             src={attractionsData.slider.images[currentImageIndex]?.src || '/images/placeholder.jpg'} 
//             alt={attractionsData.slider.images[currentImageIndex]?.title || 'Atrakcja'}
//             className="w-full h-full object-cover"
//             onError={(e) => {
//               e.target.src = '/images/placeholder.jpg';
//             }}
//           />
//           <div 
//             className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center text-white text-center cursor-pointer"
//             onClick={goToDetails}
//           >
//             <motion.h2 
//               initial={{ y: -50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.3 }}
//               className="text-4xl md:text-6xl font-bold mb-4"
//             >
//               Odkryj Jastrzębią Górę i okolice
//             </motion.h2>
//             <motion.p
//               initial={{ y: 50, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.6 }}
//               className="text-xl md:text-2xl mb-8"
//             >
//               {attractionsData.slider.images[currentImageIndex]?.title || 'Atrakcja'} - {attractionsData.slider.images[currentImageIndex]?.subtitle || 'Opis atrakcji'}
//             </motion.p>
//             <motion.button
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ delay: 0.9 }}
//               className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors duration-300"
//             >
//               Poznaj wszystkie atrakcje
//             </motion.button>
//           </div>
//         </motion.div>
//       </AnimatePresence>
      
//       {/* Pager */}
//       {attractionsData.slider.images.length > 1 && (
//         <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-2">
//           {attractionsData.slider.images.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => setCurrentImageIndex(index)}
//               className={`w-3 h-3 rounded-full ${currentImageIndex === index ? 'bg-yellow-500' : 'bg-white bg-opacity-50'}`}
//               aria-label={`Przejdź do slajdu ${index + 1}`}
//             />
//           ))}
//         </div>
//       )}

//       {/* Komunikat o błędzie */}
//       {error && (
//         <div className="absolute top-4 left-4 right-4 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
//           {error}
//         </div>
//       )}
//     </section>
//   );
// };

// export default Attractions;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';

// const Attractions = () => {
//   const API_BASE = process.env.NODE_ENV === 'production' 
//     ? '/kolorowedomki/api' 
//     : 'http://localhost/api';
  
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [attractionsData, setAttractionsData] = useState({
//     slider: {
//       images: [
//         {
//           src: '/images/latarniamorska.jpg',
//           title: 'Latarnia Morska w Rozewiu',
//           subtitle: 'Zabytkowa latarnia z muzeum latarnictwa'
//         }
//       ]
//     }
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // Załaduj dane z serwera
//   useEffect(() => {
//     const fetchAttractionsData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${API_BASE}/attractions.php`);
        
//         if (!response.ok) {
//           throw new Error('Błąd podczas pobierania danych atrakcji');
//         }
        
//         const data = await response.json();
//         setAttractionsData(data);
//       } catch (error) {
//         console.error('Błąd ładowania danych atrakcji:', error);
//         //setError('Nie udało się załadować danych atrakcji. Wyświetlam domyślną zawartość.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAttractionsData();
//   }, []);

//   useEffect(() => {
//     // Zablokuj automatyczne przewijanie przeglądarki
//     if ('scrollRestoration' in window.history) {
//       window.history.scrollRestoration = 'manual';
//     }

//     if (attractionsData.slider.images.length > 0) {
//       const interval = setInterval(() => {
//         // Zapisz aktualną pozycję scrolla
//         const scrollY = window.scrollY;
        
//         setCurrentImageIndex((prev) => (prev + 1) % attractionsData.slider.images.length);
        
//         // Natychmiast przywróć pozycję scrolla
//         requestAnimationFrame(() => {
//           window.scrollTo(0, scrollY);
//         });
//       }, 10000);
      
//       return () => {
//         clearInterval(interval);
//         // Przywróć domyślne zachowanie
//         if ('scrollRestoration' in window.history) {
//           window.history.scrollRestoration = 'auto';
//         }
//       };
//     }
//   }, [attractionsData.slider.images.length]);

//   const goToDetails = () => {
//     navigate('/atrakcje');
//   };

//   if (loading) {
//     return (
//       <section className="relative h-screen overflow-hidden bg-gray-100 flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//       </section>
//     );
//   }

//   return (
//     <section className="relative h-screen overflow-hidden">
//       {/* Tło - stałe, bez animacji */}
//       <div className="absolute inset-0">
//         <img 
//           src={attractionsData.slider.images[currentImageIndex]?.src || '/images/placeholder.jpg'} 
//           alt={attractionsData.slider.images[currentImageIndex]?.title || 'Atrakcja'}
//           className="w-full h-full object-cover"
//           onError={(e) => {
//             e.target.src = '/images/placeholder.jpg';
//           }}
//         />
//         <div className="absolute inset-0 bg-black bg-opacity-40" />
//       </div>

//       {/* Zawartość z animacją */}
//       <div 
//         className="absolute inset-0 flex flex-col items-center justify-center text-white text-center cursor-pointer"
//         onClick={goToDetails}
//       >
//         <AnimatePresence mode='popLayout'>
//           <motion.h2 
//             key={`title-${currentImageIndex}`}
//             initial={{ y: -50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             exit={{ y: -50, opacity: 0 }}
//             transition={{ duration: 0.5 }}
//             className="text-4xl md:text-6xl font-bold mb-4 px-4"
//           >
//             Odkryj Jastrzębią Górę i okolice
//           </motion.h2>

//           <motion.p
//             key={`subtitle-${currentImageIndex}`}
//             initial={{ y: 50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             exit={{ y: 50, opacity: 0 }}
//             transition={{ duration: 0.5, delay: 0.2 }}
//             className="text-xl md:text-2xl mb-8 px-4 max-w-4xl"
//           >
//             {attractionsData.slider.images[currentImageIndex]?.title || 'Atrakcja'} - {attractionsData.slider.images[currentImageIndex]?.subtitle || 'Opis atrakcji'}
//           </motion.p>
//         </AnimatePresence>

//         <motion.button
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.4 }}
//           className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors duration-300"
//         >
//           Poznaj wszystkie atrakcje
//         </motion.button>
//       </div>
      
//       {/* Pager */}
//       {attractionsData.slider.images.length > 1 && (
//         <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-2">
//           {attractionsData.slider.images.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => {
//                 const scrollY = window.scrollY;
//                 setCurrentImageIndex(index);
//                 requestAnimationFrame(() => {
//                   window.scrollTo(0, scrollY);
//                 });
//               }}
//               className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                 currentImageIndex === index ? 'bg-yellow-500 scale-110' : 'bg-white bg-opacity-50 scale-100'
//               }`}
//               aria-label={`Przejdź do slajdu ${index + 1}`}
//             />
//           ))}
//         </div>
//       )}

//       {/* Komunikat o błędzie */}
//       {error && (
//         <div className="absolute top-4 left-4 right-4 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
//           {error}
//         </div>
//       )}
//     </section>
//   );
// };

// export default Attractions;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Attractions = () => {
  const API_BASE = process.env.NODE_ENV === 'production' 
    ? '/kolorowedomki/api' 
    : 'http://localhost/api';
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [attractionsData, setAttractionsData] = useState({
    slider: {
      images: [
        {
          src: '/images/latarniamorska.jpg',
          title: 'Latarnia Morska w Rozewiu',
          subtitle: 'Zabytkowa latarnia z muzeum latarnictwa'
        },
        {
          src: '/images/klifwjastrzebiejgorze.jpg',
          title: 'Klif w Jastrzębiej Górze',
          subtitle: 'Malownicze wybrzeże klifowe'
        },
        {
          src: '/images/wawoz.jpg',
          title: 'Wąwóz Chłapowski',
          subtitle: 'Piękny rezerwat przyrody'
        },
        {
          src: '/images/plazajastrzebiagora.jpg',
          title: 'Plaże Jastrzębiej Góry',
          subtitle: 'Złociste piaski nad Bałtykiem'
        }
      ]
    },
    slideshowInterval: 10000,
    overlay: {
      enabled: true,
      gradient: "bg-gradient-to-br from-black/40 to-black/20"
    },
    titleStyle: {
      fontSize: "4xl",
      fontWeight: "bold",
      color: "#ffffff"
    },
    subtitleStyle: {
      fontSize: "xl",
      fontWeight: "normal",
      color: "#ffffff"
    }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Załaduj dane z serwera - TYLKO RAZ po odświeżeniu
  useEffect(() => {
    const fetchAttractionsData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/attractions.php?t=${Date.now()}`);
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych atrakcji');
        }
        
        const data = await response.json();
        setAttractionsData(data);
      } catch (error) {
        console.error('Błąd ładowania danych atrakcji:', error);
        // Używamy domyślnych danych w przypadku błędu
      } finally {
        setLoading(false);
      }
    };

    fetchAttractionsData();
  }, []);

  // Effect for handling the slideshow - podobnie jak w Hero
  useEffect(() => {
    if (!attractionsData.slider.images || attractionsData.slider.images.length === 0) {
      return;
    }

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => {
        return (prevIndex + 1) % attractionsData.slider.images.length;
      });
    }, attractionsData.slideshowInterval || 10000);

    return () => clearInterval(interval);
  }, [attractionsData.slideshowInterval, attractionsData.slider.images]);

  // Funkcje do bezpiecznego pobierania klas Tailwind - jak w Hero
  const getTextSizeClass = (size) => {
    const sizeMap = {
      'xs': 'text-xs',
      'sm': 'text-sm',
      'base': 'text-base',
      'lg': 'text-lg',
      'xl': 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
      '5xl': 'text-5xl',
      '6xl': 'text-6xl',
      '7xl': 'text-7xl',
      '8xl': 'text-8xl'
    };
    return sizeMap[size] || 'text-4xl';
  };

  const getFontWeightClass = (weight) => {
    const weightMap = {
      'light': 'font-light',
      'normal': 'font-normal',
      'medium': 'font-medium',
      'semibold': 'font-semibold',
      'bold': 'font-bold',
      'extrabold': 'font-extrabold',
      'black': 'font-black'
    };
    return weightMap[weight] || 'font-bold';
  };

  const goToDetails = () => {
    navigate('/atrakcje');
  };

  if (loading) {
    return (
      <section className="relative h-screen overflow-hidden bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </section>
    );
  }

  // Bezpieczne pobranie obrazków - jeśli brak, użyj domyślnych
  const backgroundImages = attractionsData.slider.images && attractionsData.slider.images.length > 0 
    ? attractionsData.slider.images 
    : [{
        src: '/images/latarniamorska.jpg',
        title: 'Latarnia Morska w Rozewiu',
        subtitle: 'Zabytkowa latarnia z muzeum latarnictwa'
      }];

  return (
    <section className="relative h-screen overflow-hidden">
      {/* Background images container - jak w Hero */}
      <div className="absolute inset-0">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentImageIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {/* Zdjęcie tła */}
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{ 
                backgroundImage: `url('${image.src}')`,
                backgroundPosition: 'center',
                backgroundSize: 'cover'
              }}
            />
            
            {/* Overlay - jak w Hero */}
            {attractionsData.overlay?.enabled && (
              <div className={`absolute inset-0 ${attractionsData.overlay.gradient || 'bg-gradient-to-br from-black/40 to-black/20'}`} />
            )}
          </div>
        ))}
      </div>

      {/* Zawartość z animacją */}
      <div 
        className="absolute inset-0 flex flex-col items-center justify-center text-white text-center cursor-pointer z-10"
        onClick={goToDetails}
      >
        <AnimatePresence mode='popLayout'>
          <motion.h2 
            key={`title-${currentImageIndex}`}
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transition={{ duration: 0.5 }}
            className={`${getTextSizeClass(attractionsData.titleStyle?.fontSize)} ${getFontWeightClass(attractionsData.titleStyle?.fontWeight)} mb-4 px-4 drop-shadow-2xl`}
            style={{ color: attractionsData.titleStyle?.color || '#ffffff' }}
          >
            Odkryj Jastrzębią Górę i okolice
          </motion.h2>

          <motion.p
            key={`subtitle-${currentImageIndex}`}
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className={`${getTextSizeClass(attractionsData.subtitleStyle?.fontSize)} ${getFontWeightClass(attractionsData.subtitleStyle?.fontWeight)} mb-8 px-4 max-w-4xl drop-shadow-2xl`}
            style={{ color: attractionsData.subtitleStyle?.color || '#ffffff' }}
          >
            {backgroundImages[currentImageIndex]?.title || 'Atrakcja'} - {backgroundImages[currentImageIndex]?.subtitle || 'Opis atrakcji'}
          </motion.p>
        </AnimatePresence>

        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors duration-300 drop-shadow-2xl"
        >
          Poznaj wszystkie atrakcje
        </motion.button>
      </div>
      
      {/* Pager - jak w Hero */}
      {backgroundImages.length > 1 && (
        <div className="absolute bottom-8 left-0 right-0 flex justify-center space-x-2 z-10">
          {backgroundImages.map((_, index) => (
            <button
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                setCurrentImageIndex(index);
              }}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                currentImageIndex === index ? 'bg-yellow-500 scale-110' : 'bg-white bg-opacity-50 scale-100'
              }`}
              aria-label={`Przejdź do slajdu ${index + 1}`}
            />
          ))}
        </div>
      )}

      {/* Komunikat o błędzie */}
      {error && (
        <div className="absolute top-4 left-4 right-4 bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded z-50">
          {error}
        </div>
      )}
    </section>
  );
};

export default Attractions;